export type Linkedin_facet = {
    name: string
    urn: string
    facetUrn: string
}

export const Seniorities : Linkedin_facet[] = [{
    'facetUrn': 'urn:li:adTargetingFacet:seniorities',
    'name': 'Unpaid',
    'urn': 'urn:li:seniority:1'
  }, {
    'facetUrn': 'urn:li:adTargetingFacet:seniorities',
    'name': 'Training',
    'urn': 'urn:li:seniority:2'
  }, {
    'facetUrn': 'urn:li:adTargetingFacet:seniorities',
    'name': 'Entry',
    'urn': 'urn:li:seniority:3'
  }, {
    'facetUrn': 'urn:li:adTargetingFacet:seniorities',
    'name': 'Senior',
    'urn': 'urn:li:seniority:4'
  }, {
    'facetUrn': 'urn:li:adTargetingFacet:seniorities',
    'name': 'Manager',
    'urn': 'urn:li:seniority:5'
  }, {
    'facetUrn': 'urn:li:adTargetingFacet:seniorities',
    'name': 'Director',
    'urn': 'urn:li:seniority:6'
  }, {
    'facetUrn': 'urn:li:adTargetingFacet:seniorities',
    'name': 'VP',
    'urn': 'urn:li:seniority:7'
  }, {
    'facetUrn': 'urn:li:adTargetingFacet:seniorities',
    'name': 'CXO',
    'urn': 'urn:li:seniority:8'
  }, {
    'facetUrn': 'urn:li:adTargetingFacet:seniorities',
    'name': 'Owner',
    'urn': 'urn:li:seniority:10'
  }, {
    'facetUrn': 'urn:li:adTargetingFacet:seniorities',
    'name': 'Partner',
    'urn': 'urn:li:seniority:9'
  }]
  
export const StaffCounts : Linkedin_facet[] = [{
    'name': 'Myself Only',
    'urn': 'urn:li:staffCountRange:(1,1)',
    'facetUrn': 'urn:li:adTargetingFacet:staffCountRanges'
  }, {
    'name': '2-10 employees',
    'urn': 'urn:li:staffCountRange:(2,10)',
    'facetUrn': 'urn:li:adTargetingFacet:staffCountRanges'
  }, {
    'name': '11-50 employees',
    'urn': 'urn:li:staffCountRange:(11,50)',
    'facetUrn': 'urn:li:adTargetingFacet:staffCountRanges'
  }, {
    'name': '51-200 employees',
    'urn': 'urn:li:staffCountRange:(51,200)',
    'facetUrn': 'urn:li:adTargetingFacet:staffCountRanges'
  }, {
    'name': '201-500 employees',
    'urn': 'urn:li:staffCountRange:(201,500)',
    'facetUrn': 'urn:li:adTargetingFacet:staffCountRanges'
  }, {
    'name': '501-1000 employees',
    'urn': 'urn:li:staffCountRange:(501,1000)',
    'facetUrn': 'urn:li:adTargetingFacet:staffCountRanges'
  }, {
    'name': '1001-5000 employees',
    'urn': 'urn:li:staffCountRange:(1001,5000)',
    'facetUrn': 'urn:li:adTargetingFacet:staffCountRanges'
  }, {
    'name': '5001-10,000 employees',
    'urn': 'urn:li:staffCountRange:(5001,10000)',
    'facetUrn': 'urn:li:adTargetingFacet:staffCountRanges'
  }, {
    'name': '10,001+ employees',
    'urn': 'urn:li:staffCountRange:(10001,2147483647)',
    'facetUrn': 'urn:li:adTargetingFacet:staffCountRanges'
  }]
  
  
  export const JobFunctions : Linkedin_facet[] = [{
    'name': 'Accounting',
    'urn': 'urn:li:function:1',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Administrative',
    'urn': 'urn:li:function:2',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Arts and Design',
    'urn': 'urn:li:function:3',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Business Development',
    'urn': 'urn:li:function:4',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Community and Social Services',
    'urn': 'urn:li:function:5',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Consulting',
    'urn': 'urn:li:function:6',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Education',
    'urn': 'urn:li:function:7',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Engineering',
    'urn': 'urn:li:function:8',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Entrepreneurship',
    'urn': 'urn:li:function:9',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Finance',
    'urn': 'urn:li:function:10',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Healthcare Services',
    'urn': 'urn:li:function:11',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Human Resources',
    'urn': 'urn:li:function:12',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Information Technology',
    'urn': 'urn:li:function:13',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Legal',
    'urn': 'urn:li:function:14',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Marketing',
    'urn': 'urn:li:function:15',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Media and Communication',
    'urn': 'urn:li:function:16',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Military and Protective Services',
    'urn': 'urn:li:function:17',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Operations',
    'urn': 'urn:li:function:18',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Product Management',
    'urn': 'urn:li:function:19',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Program and Project Management',
    'urn': 'urn:li:function:20',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Purchasing',
    'urn': 'urn:li:function:21',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Quality Assurance',
    'urn': 'urn:li:function:22',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Real Estate',
    'urn': 'urn:li:function:23',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Research',
    'urn': 'urn:li:function:24',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Sales',
    'urn': 'urn:li:function:25',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }, {
    'name': 'Customer Success and Support',
    'urn': 'urn:li:function:26',
    'facetUrn': 'urn:li:adTargetingFacet:jobFunctions'
  }]
  
  
  export const GrowthRates : Linkedin_facet[] = [{
      'name': 'Negative growth companies',
      'urn': 'urn:li:growthRate:(-2147483647,0)',
      'facetUrn': 'urn:li:adTargetingFacet:growthRate'
  }, {
      'name': '0% - 3% company growth',
      'urn': 'urn:li:growthRate:(0,3)',
      'facetUrn': 'urn:li:adTargetingFacet:growthRate'
  }, {
      'name': '3% - 10% company growth',
      'urn': 'urn:li:growthRate:(3,10)',
      'facetUrn': 'urn:li:adTargetingFacet:growthRate'
  }, {
      'name': '10% - 20% company growth',
      'urn': 'urn:li:growthRate:(10,20)',
      'facetUrn': 'urn:li:adTargetingFacet:growthRate'
  }, {
      'name': '20%+ company growth',
      'urn': 'urn:li:growthRate:(20,2147483647)',
      'facetUrn': 'urn:li:adTargetingFacet:growthRate'
  }]
  
  
  
export const Revenues : Linkedin_facet[] = [{
      'name': 'Under $1M',
      'urn': 'urn:li:revenue:(-2147483647,1)',
      'facetUrn': 'urn:li:adTargetingFacet:revenue'
  }, {
      'name': '$1M-$10M',
      'urn': 'urn:li:revenue:(1,10)',
      'facetUrn': 'urn:li:adTargetingFacet:revenue'
  }, {
      'name': '$10M-$100M',
      'urn': 'urn:li:revenue:(10,100)',
      'facetUrn': 'urn:li:adTargetingFacet:revenue'
  }, {
      'name': '$100M-$1B',
      'urn': 'urn:li:revenue:(100,1000)',
      'facetUrn': 'urn:li:adTargetingFacet:revenue'
  }, {
      'name': '$1B+',
      'urn': 'urn:li:revenue:(1000,2147483647)',
      'facetUrn': 'urn:li:adTargetingFacet:revenue'
  }]
  
  
  export const MemberBehaviors : Linkedin_facet[] = [{
      'name': 'Frequent Travelers',
      'urn': 'urn:li:memberBehavior:9',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Job Seekers',
      'urn': 'urn:li:memberBehavior:12',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Open to Education',
      'urn': 'urn:li:memberBehavior:13',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Frequent Contributors',
      'urn': 'urn:li:memberBehavior:14',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Recently Relocated',
      'urn': 'urn:li:memberBehavior:15',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Recently Promoted',
      'urn': 'urn:li:memberBehavior:18',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Career Changers',
      'urn': 'urn:li:memberBehavior:19',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Recently Switched Jobs',
      'urn': 'urn:li:memberBehavior:20',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Open to Relocation',
      'urn': 'urn:li:memberBehavior:21',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Ex-pat',
      'urn': 'urn:li:memberBehavior:24',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Mobile Users',
      'urn': 'urn:li:memberBehavior:2',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Desktop/Laptop Users',
      'urn': 'urn:li:memberBehavior:5',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Domestic Frequent Travelers',
      'urn': 'urn:li:memberBehavior:10',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'International Frequent Travelers',
      'urn': 'urn:li:memberBehavior:11',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Recently Relocated (Domestic)',
      'urn': 'urn:li:memberBehavior:16',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Recently Relocated (International)',
      'urn': 'urn:li:memberBehavior:17',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Open to Relocation (Domestic)',
      'urn': 'urn:li:memberBehavior:22',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Open to Relocation (International)',
      'urn': 'urn:li:memberBehavior:23',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Android Users',
      'urn': 'urn:li:memberBehavior:4',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Windows',
      'urn': 'urn:li:memberBehavior:6',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Mac',
      'urn': 'urn:li:memberBehavior:7',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
  }, {
      'name': 'Linux',
      'urn': 'urn:li:memberBehavior:8',
      'facetUrn': 'urn:li:adTargetingFacet:memberBehaviors'
}]


export const map_facet_to_combobox_values = (facets: Linkedin_facet[]) => {
    return facets.map((f) => {
        return {key: f.urn, display: f.name}
    })
}
